<footer class="py-0.5 text-center text-sm bg-primary-container">
  <p class="font-bold">&copy; 2026 SenseWay Inc. All rights reserved.</p>
</footer>
